import React  from 'react'
import Carousel from "react-bootstrap/Carousel";


export const Sliders = () => {

    // const videos= [
    //     "https://www.canva.com/design/DAFsYZjVsVY/watch",
    //     "https://www.canva.com/design/DAFs1057I3k/watch",
    //     "https://media.istockphoto.com/id/1379495441/es/v%C3%ADdeo/im%C3%A1genes-de-video-4k-de-cient%C3%ADficos-que-trabajan-en-un-laboratorio.mp4?s=mp4-640x640-is&k=20&c=a7Frw3Jhx_JHTkoTQA2sFiCexUFhrZQb43DNjFjdJ9E=",
        

    // ]
    
    
    
    
    return (

        <Carousel  >
            {/* <Carousel.Item interval={40000} >
               <video id="video1"
                src={video1}
                autoPlay= {true}
                loop= {true}
                muted
                width={"100%"}
                
                />
                <Carousel.Caption>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item interval={10000}>
            <video id="video2"
                src={video2}
                autoPlay= {true}
                loop= {true}
                muted
                width={"100%"}
                
                />
                <Carousel.Caption>
                </Carousel.Caption>
            </Carousel.Item> */}
          
        </Carousel>
      
        // // Render a YouTube video player
        // <ReactPlayer 
        // url={videos[0]}
        // playing
        // playsinline={true}
        // volume={0.5}
        // controls
        // muted={true}
        // width={"100%"}
        // onReady={(e) => {
        //     const player = e.getInternalPlayer();
        //     player.setAttribute('muted', 'true');
        // }}
       
        
        // />
   
        

        
        
  )
}



